import {Form, Input, InputNumber, Radio, Spin} from 'antd'
import {PublisherBean} from 'common/api/api'
import {publisherApi} from 'common/api/entitiesApi.tsx'
import {AnchorsForm} from 'common/components/AnchorsForm.tsx'
import {ButtonsPanel} from 'common/components/ButtonsPanel.tsx'
import {TimeZoneSelector} from 'common/components/dictionary/TimeZoneSelector.tsx'
import {FormCard} from 'common/components/FormCard.tsx'
import {useAppContext} from 'common/context/AppContext.tsx'
import {CommonRoutes} from 'common/context/commonRoutes'
import { queueListRepositionOnModifiedChange } from 'common/util/listNavigation.ts';
import {apiCall, FormMode} from 'common/util/Util.tsx'
import React, {useEffect, useState} from 'react'
import {useNavigate, useParams} from 'react-router-dom'
import SellerTypeEnum = PublisherBean.SellerTypeEnum

const FormItem = Form.Item

interface PublisherFormProps {
    mode: 'create' | 'edit'
}

const PublisherForm: React.FC<PublisherFormProps> = ({ mode }) => {
    const navigateTo = useNavigate()
    const appContext = useAppContext()
    const [entity, setEntity] = useState<PublisherBean>({} as PublisherBean)

    const { id } = useParams<{ id?: string }>()
    const idNum = id ? parseInt(id) : 0

    const [form] = Form.useForm()

    const [loading, setLoading] = useState(() => false)

    const handleSubmit = () => {
        setLoading(true)
        form.validateFields().then((values) => {
            if (mode === 'create') {
                apiCall(
                    setLoading,
                    appContext,
                    () => publisherApi.createPublisher({ ...values }),
                    () => navigateTo(CommonRoutes.PUBLISHER))
            } else {
                apiCall(
                    setLoading,
                    appContext,
                    () => publisherApi.editPublisher({ ...values }, idNum),
                    (response) => {
                        queueListRepositionOnModifiedChange({
                            appContext,
                            routeKey: CommonRoutes.PUBLISHER,
                            previousEntity: entity,
                            responseEntity: response?.data
                        })

                        navigateTo(CommonRoutes.PUBLISHER)
                    })
            }
        })
    }

    const onCancel = () => {
        navigateTo(CommonRoutes.PUBLISHER)
    }

    const onDelete = () => {
        apiCall(setLoading, appContext, () => publisherApi.deletePublisher(idNum), () => navigateTo(CommonRoutes.PUBLISHER))
    }

    const loadData = async () => {
        if (mode === 'edit') {
            apiCall(setLoading, appContext, () => publisherApi.publisher(idNum),
                (res) => {
                    if (res?.data) {
                        setEntity(res.data)
                        form.setFieldsValue({ ...res.data })
                    }
                })
        }
    }

    useEffect(() => {
        loadData()
    }, [])

    return (
        <Spin spinning={loading}>
            <AnchorsForm form={form} onFinish={handleSubmit}>
                <FormCard
                    id="publisher"
                    title="Publisher"
                >
                    <FormItem
                        required
                        name="name"
                        rules={[{ required: true, message: 'Please input Publisher name' }]} label="Name"
                    >
                        <Input />
                    </FormItem>
                    <FormItem name="revShare" rules={[{ required: true, message: 'RevShare is required' }]}
                              label="RevShare">
                        <InputNumber step={1} min={0} max={99} style={{ width: '100px' }} addonAfter="%" />
                    </FormItem>
                    <FormItem name="timeZoneId" rules={[{ required: true, message: 'Please select Time Zone' }]}
                              label="Time Zone"
                    >
                        <TimeZoneSelector />
                    </FormItem>
                    <FormItem
                        name="domain"
                        label="Domain"
                    >
                        <Input />
                    </FormItem>
                    <FormItem name="sellerType" label="Seller Type" initialValue={SellerTypeEnum.Publisher}>
                        <Radio.Group>
                            {Object.values([SellerTypeEnum.Publisher, SellerTypeEnum.Intermediary, SellerTypeEnum.Both]).map((mode) => (
                                <Radio key={mode} value={mode}>
                                    {mode}
                                </Radio>
                            ))}
                        </Radio.Group>
                    </FormItem>
                </FormCard>
                <ButtonsPanel onCancel={onCancel} showDelete={mode === FormMode.edit}
                              onDelete={onDelete} />

            </AnchorsForm>
        </Spin>
    )
}

export default PublisherForm 
